<template>
    <div>
        <template v-if="alwaysUpload">
            <image-creator
                :default-alt="defaultAlt"
                :allow-edit-alt="allowEditAlt"
                :default-size="defaultSize"
                @created="onCreated"
                @loading="$emit('loading', $event)"
            />
        </template>

        <template v-else>
            <div v-if="hoverMode">
                <button
                    class="group relative w-24 h-24 md:w-36 md:h-36 overflow-hidden rounded-full border-2 border-theme-border flex-shrink-0 focus:outline-none"
                >
                    <img
                        v-if="currentUrl"
                        :src="currentUrl"
                        :alt="defaultAlt"
                        class="w-full h-full object-cover"
                    />

                    <!-- Overlay -->
                    <div
                        class="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 text-white text-sm font-semibold opacity-0 group-hover:opacity-100 transition duration-200"
                        @click="openSelector"
                    >
                        Editar
                    </div>
                </button>
            </div>
            <div
                v-else-if="currentUrl"
                class="flex flex-col items-center gap-3"
            >
                <img
                    :src="currentUrl"
                    :alt="defaultAlt || 'imagen'"
                    class="rounded-xl border border-theme-border object-contain bg-theme-canvas"
                    :style="{
                        width: previewWidth + 'px',
                        height: previewHeight + 'px'
                    }"
                />
                <app-button border icon @click="openSelector">✏️</app-button>
            </div>

            <div v-else class="flex justify-center">
                <button
                    class="rounded-xl border-2 border-dashed border-theme-primary flex flex-col items-center justify-center gap-1.5 text-theme-muted hover:border-stack-primary hover:text-stack-primary transition-colors cursor-pointer"
                    :style="{
                        width: previewWidth + 'px',
                        height: previewHeight + 'px'
                    }"
                    @click="openSelector"
                >
                    <span class="text-2xl">🖼</span>
                    <span class="text-xs font-medium">{{
                        defaultAlt || "Seleccionar imagen"
                    }}</span>
                </button>
            </div>

            <image-selector
                v-model="selectorOpen"
                :enabled-create="true"
                :default-alt="defaultAlt"
                :allow-edit-alt="allowEditAlt"
                :default-size="defaultSize"
                @input="onSelected"
            />
        </template>
    </div>
</template>

<script>
import ImageCreator from "@/components/utils/ImageCreator.vue";
import ImageSelector from "@/components/utils/ImageSelector.vue";

export default {
    name: "UrlImageManager",
    components: { ImageCreator, ImageSelector },
    props: {
        currentUrl: {
            type: String,
            default: ""
        },
        defaultAlt: {
            type: String,
            default: ""
        },
        allowEditAlt: {
            type: Boolean,
            default: true
        },
        hoverMode: {
            type: Boolean,
            default: false
        },
        defaultSize: {
            type: String,
            default: ""
        },
        previewWidth: {
            type: Number,
            default: 200
        },
        previewHeight: {
            type: Number,
            default: 80
        },
        alwaysUpload: {
            type: Boolean,
            default: false
        }
    },
    emits: ["updated", "loading"],
    data: () => ({
        selectorOpen: false
    }),
    methods: {
        openSelector() {
            this.selectorOpen = true;
        },
        onSelected(image) {
            if (image.url) this.$emit("updated", image.url, image);
        },
        onCreated(image) {
            this.$emit("updated", image.url, image);
        }
    }
};
</script>
